import qrcode from "./qrcode-generator.js";

export function classroomProjectionUrl(state: { classId?: number | null }) {
  const url = new URL(window.location.href);
  url.search = "";
  url.hash = "";
  url.searchParams.set("classroom", "1");
  if (state?.classId) url.searchParams.set("class", String(state.classId));
  return url.toString();
}

export function drawQrToCanvas(canvas: HTMLCanvasElement, text: string, size = 72) {
  const qr = qrcode(0, "M");
  qr.addData(text);
  qr.make();
  const moduleCount = qr.getModuleCount();
  const margin = 4;
  const cell = Math.max(1, Math.floor((size - margin * 2) / moduleCount));
  const drawSize = cell * moduleCount;
  const offset = Math.floor((size - drawSize) / 2);
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext("2d");
  if (!ctx) return;
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, size, size);
  ctx.fillStyle = "#1f1b16";
  for (let row = 0; row < moduleCount; row += 1) {
    for (let col = 0; col < moduleCount; col += 1) {
      if (qr.isDark(row, col)) {
        ctx.fillRect(offset + col * cell, offset + row * cell, cell, cell);
      }
    }
  }
}
